import React from 'react';
import { Icon } from '@fourthwall/components';
import { TickIcon } from '@fourthwall/icons';
import * as S from './KitConnected.styled';
export const KitConnected = () => {
    return (React.createElement(S.Container, null,
        React.createElement(S.Title, null,
            React.createElement(Icon, { component: TickIcon, width: 24, height: 24 }),
            React.createElement("div", null, "Successfully Connected to Kit")),
        React.createElement(S.Description, null, "Your Fourthwall shop is now connected to Kit. You can now sync your supporter data and create powerful email marketing campaigns to engage with your community.")));
};
